export function getPacContainerClass(
  widget: boolean,
  colorMode: string,
): string {
  if (widget && colorMode === "light") {
    return "light-pac-container";
  }
  if (colorMode === "black") {
    return "black-pac-container";
  }
  return "dark-pac-container";
}

export function getHeaderContainerClass(
  widget: boolean,
  colorMode: string,
): string {
  if (widget && colorMode === "light") {
    return "light-header-container";
  }
  if (colorMode === "black") {
    return "black-header-container";
  }
  return "";
}

export function getMenuButtonClass(widget: boolean, colorMode: string): string {
  if (widget && colorMode === "light") {
    return "light-menu-button";
  }
  if (colorMode === "black") {
    return "black-menu-button";
  }
  return "";
}
